import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { projectMutationKeys } from '../constants'
import { getOrganizationId } from '../../authentication/query/use-me-query'

export const useCheckChildrenNameIsAvailableMutation = (options) => {
  const organizationId = getOrganizationId()

  const handleMutation = async ({
    destinationFolderId = organizationId,
    selectedItemNames
  }) => {
    const config = {
      method: 'post',
      data: selectedItemNames
    }

    const { data } = await api(
      `/api/v2/projectFolders/${destinationFolderId}/childrenNames`,
      config
    )

    return data
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: projectMutationKeys.CHECK_CHILDREN_NAME_IS_AVAILABLE,
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      return options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      return options?.onError?.(error, variables, context)
    }
  })
}
